module.exports = __webpack_public_path__ + "static/military_saddle_mtg_clb-71b994f6518bd2bc28cc7cd5c0209234.webp";